import { SB, createSharedStateSchema } from '@play-co/replicant';
import migrator from './migrations/migrator';

export const teamProfileSchema = SB.object({
  name: SB.string(),
  description: SB.string(),
  icon: SB.string(),
  levelRequired: SB.int().default(0),
});

export const teamEventsSchema = SB.map(
  SB.object({
    type: SB.string(),
    sharedStateId: SB.string(),
    score: SB.number(),
    createdAt: SB.number(),
    modifiedAt: SB.number(),
    targetScore: SB.number().optional(),
  }),
);

export const teamSharedStateSchema = createSharedStateSchema({
  user: {
    schema: SB.object({
      blockedUsers: SB.array(SB.string()),
    }),
  },
  global: {
    schema: SB.object({
      profile: teamProfileSchema,
      events: teamEventsSchema,
      members: SB.map(
        SB.object({
          joinedAt: SB.number(),
          role: SB.string(),
          helps: SB.array(
            SB.object({
              createdAt: SB.number(),
              target: SB.string(),
              type: SB.string(),
              requestId: SB.number(),
            }),
          ),
          contributions: SB.map(
            SB.object({
              claimedRewardsAt: SB.number().optional(),
              score: SB.number(),
              createdAt: SB.number(),
              modifiedAt: SB.number(),
            }),
          ),
        }),
      ),
      chat: SB.array(
        SB.object({
          sentAt: SB.number(),
          senderId: SB.string(),
          contents: SB.object({
            type: SB.string(),
            id: SB.string().optional(),
            value: SB.int().optional(),
          }),
        }),
      ),
      createdTimestamp: SB.number(),
      modifiedAt: SB.number(),
    }),
    migrator,
  },
});

export type TeamState = {
  global: SB.ExtractType<typeof teamSharedStateSchema.global.schema>;
};
export type TeamProfile = SB.ExtractType<typeof teamProfileSchema>;
export type TeamExtendedProfile = TeamProfile & {
  id: string;
  memberCount: number;
  member: boolean;
  score: number;
  helps: number;
};

export type ChatMessage = SB.ExtractType<
  (typeof teamSharedStateSchema)['global']['schema']
>['chat'][number];

export const teamStateSchema = {
  team: SB.object({
    currentTeamId: SB.string().optional(),
    autoCareRequest: SB.boolean().default(true),
    lastEnergyRequestTimestamp: SB.int().default(0),
    lastCompetitionEventId: SB.string().optional(),
    seenCompetitionInfo: SB.boolean().optional(),
    lastSeenMessageTimestamp: SB.int().default(0),
  }),
};
